import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { FIRE } from '@/media/entity/SetupPreset';
import MetricMap from '@/metric/components/MetricMap/MetricMap';
import Diamond from '@/product/entity/Diamond';

export const FIELD_SCINTILLATION_MAP: Field = {
  key: 'scintillationMap',
  label: 'Scintillation Map',
  fullLabel: 'Scintillation Map',
  type: FieldType.Media,
  spGroupId: null,
  getValue(p) {
    if (p instanceof Diamond && p.scintillationMetric) {
      return p.scintillationMetric.map;
    }

    return null;
  },
  getText() {
    return null;
  },
  render(p, { viewSettings, maxScale } = {}) {
    if (p instanceof Diamond && p.scintillationMetric && viewSettings) {
      return (
        <MetricMap
          aria-label="Scintillation map chart"
          isSingleScaleEnabled={viewSettings.resultedIsSingleScale}
          maxScale={maxScale}
          mediaSize={viewSettings.mediaSize!}
          metric={p.scintillationMetric}
          product={p}
          setupPresetId={FIRE}
        />
      );
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
